import InfiniteDataList from './infinite-data-list';
import './infinite-data-list.scss';

export default InfiniteDataList;
